import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import CallPage from "../pages/call";
import NotFoundPage from "../pages/404";

const MainRouter: React.FC = () => (
  <Router>
    <Routes>
      <Route path="/call/:id" element={<CallPage />} />
      <Route path="/404" element={<NotFoundPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  </Router>
);

export default MainRouter;
